require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-donates-usd-5-000-to-st-vincent-de-paul-food-pantry.json") })
        }
      }, "path---articles-financial-center-donates-usd-5-000-to-st-vincent-de-paul-food-pantry");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-donates-usd-5-000-to-st-vincent-de-paul-food-pantry!./.cache/json/articles-financial-center-donates-usd-5-000-to-st-vincent-de-paul-food-pantry.json
// module id = 1607
// module chunks = 231608221292675